<!--
 * @Author: WeijianXu weijian.xu@unidt.com
 * @Date: 2024-04-10 15:24:38
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-04-10 17:24:15
 * @FilePath: \intelligent-knowledge-qa-pcd:\app\reps\ai-qa\assistant_portal_web\src\components\frame\DialogCertificate.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <el-dialog
    :model-value="visible"
    destroy-on-close
    width="400px"
    :before-close="handleClose"
    class="resource_dialog"
    :close-on-click-modal="false"
    :title="'用户信息'"
  >
    <el-form
      ref="form"
      :model="formData"
      :rules="formRules"
      class="form"
      label-position="top"
      @submit.prevent="submitForm('form')"
    >
      <!-- <el-form-item label="手机号" prop="phone">
        <el-input
          v-model="phoneNew"
          disabled="true"
          maxlength="11"
          autocomplete="off"
          placeholder="请输入"
          size="large"
        />
      </el-form-item> -->
      <el-form-item label="用户名" prop="userName">
        <el-input v-model="formData.userName" maxlength="12" autocomplete="off" placeholder="请输入" size="large" />
      </el-form-item>
      <!-- <el-form-item label="地区" prop="address">
        <el-input v-model="formData.address" maxlength="12" autocomplete="off" placeholder="请输入" size="large" />
      </el-form-item> -->
      <el-form-item label="头像" prop="avatar">
        <Upload
          v-model="formData.avatar"
          btn-text=""
          :uploadUrl="'/asset/upload/online/upload'"
          :view-text="formData?.avatar?.url ? '点击查看头像' : ''"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" :loading="formLoading" @click="submitForm(form)">保存</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { reactive, ref } from 'vue';
import { certificatePersonel, euserEdit } from '@/data/ApiPersonnel';
import { ElMessage } from 'element-plus';
import storeAccount from '@/config/storeAccount.js';
import userStore from '@/config/store-euser.js';
import Upload from '../../upload';
// import { useRouter } from 'vue-router';
export default {
  props: {
    visible: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    Upload,
  },
  emits: ['update:visible'],
  setup(props, ctx) {
    const form = ref();
    const formLoading = ref(false);
    const account = storeAccount();
    const euser = userStore();
    // const router = useRouter()
    let formData = ref({
      phid: account.info.phid,
      phone: euser.eUserInfo.phone || undefined,
      userName: euser.eUserInfo.userName || undefined,
      // address: euser.eUserInfo.address || undefined,
    });

    formData.value.userName = euser.eUserInfo.userName; //ref(euser.eUserInfo.phone || euser.eUserInfo.userName);
    formData.value.avatar = { url: euser.eUserInfo.avatar };
    // console.log('userStore', euser.eUserInfo.avatar);

    const formRules = reactive({
      // phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
      userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
      // address: [{ required: false, message: '请输入地区', trigger: 'blur' }],
    });

    //表单操作
    const handleClose = () => {
      ctx.emit('update:visible', false);
    };
    const submitForm = (form) => {
      let postData = {
        avatar: formData.value?.avatar?.url || '',
        userName: formData.value.userName,
        // phid: account.info.phid,
      };

      form.validate((valid) => {
        if (valid) {
          euserEdit(postData)
            .then((res) => {
              ElMessage.success('修改成功');
              handleClose();
              account.GetUserInfo();
              euser.hasEName = true;
            })
            .finally(() => {
              formLoading.value = false;
            });
        } else {
          return false;
        }
      });
    };
    return {
      form,
      formRules,
      formData,
      // phoneNew,
      formLoading,
      handleClose,
      submitForm,
    };
  },
};
</script>
<style lang="scss" scoped></style>
